import { render, staticRenderFns } from "./PcRiskController.vue?vue&type=template&id=6eabb72a&scoped=true&"
import script from "./PcRiskController.vue?vue&type=script&lang=js&"
export * from "./PcRiskController.vue?vue&type=script&lang=js&"
import style0 from "./PcRiskController.vue?vue&type=style&index=0&id=6eabb72a&prod&lang=scss&"
import style1 from "./PcRiskController.vue?vue&type=style&index=1&id=6eabb72a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eabb72a",
  null
  
)

/* custom blocks */
import block0 from "./PcRiskController.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports